import { Trans } from "@lingui/react/macro";
import React from "react";
import {
  SectionContainer,
  OpeningText,
  OpeningTextHeading
} from "@silversea-ssc/ui-components-react";
import GlobalSearch from "components/GlobalSearch/GlobalSearch";
import { graphql, HeadProps, PageProps } from "gatsby";
import { GlobalSearchPageQuery } from "types/graphql-types";
import { PageContext } from "types/pageContext";
import GatsbyHeadOpenGraph from "components/SEO/GatsbyHeadOpenGraph";

const GlobalSearchPage: React.FC<PageProps<GlobalSearchPageQuery>> = ({
  data
}) => {
  return (
    <React.Fragment>
      <SectionContainer spacingTop="regular">
        <OpeningText>
          <OpeningTextHeading>
            <Trans id="search-page-title">Search</Trans>
          </OpeningTextHeading>
        </OpeningText>
      </SectionContainer>
      <GlobalSearch
        fycPagePath={data?.FYCPage?.path}
        cruisePromosContent={data.cruisePromosContent}
        shipsContent={data.shipsContent}
      />
    </React.Fragment>
  );
};

export const Head = (props: HeadProps<GlobalSearchPageQuery, PageContext>) => {
  const { pageContext } = props;

  return (
    <GatsbyHeadOpenGraph
      path={props.location.pathname}
      alternateLinks={pageContext.alternateLinks}
      languageCode={pageContext.languageCode}
      //openGraph={data.page?.metadata?.openGraph}
      excludeFromSitemap={true}
    />
  );
};

export const query = graphql`
  query GlobalSearchPage($languageCode: String!) {
    cruisePromosContent {
      ...FYCPromosContent
    }
    shipsContent {
      ...FYCShipsContent
    }

    FYCPage: sitePage(
      context: {
        sanityId: { regex: "/page-cruise$/" }
        languageCode: { eq: $languageCode }
      }
    ) {
      path
    }
  }
`;

export default GlobalSearchPage;
